import React from "react";

const plans = [
  {
    title: "BIKE < 200CC",
    price: "₹700.00",
    features: [
      "Inspection",
      "Preparation",
      "Application of Cleaning Fluid",
      "Hydrogen Cleaning",
      "Monitoring",
      "Final Inspection",
    ],
  },
  {
    title: "BIKE > 200CC",
    price: "₹1000.00",
    features: [
      "Inspection",
      "Preparation",
      "Application of Cleaning Fluid",
      "Hydrogen Cleaning",
      "Monitoring",
      "Final Inspection",
    ],
  },
  {
    title: "CAR < 1200CC",
    price: "₹2000.00",
    features: [
      "Inspection",
      "Preparation",
      "Application of Cleaning Fluid",
      "Hydrogen Cleaning",
      "Monitoring",
      "Final Inspection",
    ],
  },
  {
    title: "SEDAN CARS",
    price: "₹2500.00",
    features: [
      "Inspection",
      "Preparation",
      "Application of Cleaning Fluid",
      "Hydrogen Cleaning",
      "Monitoring",
      "Final Inspection",
    ],
  },
  {
    title: "SUV CARS",
    price: "₹3000.00",
    features: [
      "Inspection",
      "Preparation",
      "Application of Cleaning Fluid",
      "Hydrogen Cleaning",
      "Monitoring",
      "Final Inspection",
    ],
  },
  {
    title: "TRUCK, BUS, JCB, CRANE",
    price: "₹5500.00",
    features: [
      "Inspection",
      "Preparation",
      "Application of Cleaning Fluid",
      "Hydrogen Cleaning",
      "Monitoring",
      "Final Inspection",
    ],
  },
];

const PricingPlans = () => {
  const handleBookNow = (plan) => {
    const phoneNumber = "+917017774127";
    const message = `Hi! I'm interested in booking the service for*${
      plan.title
    }* .

🚗 Service: ${plan.title}
💰 Price: ${plan.price || "To be discussed"}

This service includes:
${
  plan.features?.map((feature) => `• ${feature}`).join("\n") ||
  "Details not provided"
}

Could you please help me schedule an appointment? Thank you!`;

    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <div className="bg-gray-50 py-12 sm:px-10 px-4">
      {/* Heading */}
      <div className="text-center mb-12">
        <div className="mb-4">
          <h1 className="text-4xl font-bold text-gray-800 leading-relaxed">
            Carbon Cleaning Plan
          </h1>
        </div>
        <div>
          <h2 className="text-2xl text-gray-600">Choose Your Plan</h2>
        </div>
      </div>

      {/* Plans */}
      <div className="w-full mx-auto px-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {plans.map((plan, idx) => (
          <div
            key={idx}
            className="bg-white rounded-lg shadow-lg p-6 border border-gray-200 
             transition-all duration-300 
             hover:shadow-xl hover:border-orange-600 
             hover:scale-[1.02]"
          >
            <div className="text-center mb-6">
              <h3 className="text-xl font-bold text-gray-800 mb-2">
                {plan.title}
              </h3>
              <div className="text-3xl font-bold text-green-600 mb-4">
                {plan.price}
              </div>
            </div>

            <ul className="space-y-3 mb-8">
              {plan.features.map((feature, i) => (
                <li key={i} className="flex items-center text-gray-700">
                  <span className="text-green-500 mr-2">✓</span>
                  {feature}
                </li>
              ))}
            </ul>

            <button
              onClick={() => handleBookNow(plan)}
              className="w-full bg-green-600 text-white py-3 px-6 rounded-lg font-semibold transition-colors duration-300 hover:text-white hover:bg-orange-600"
            >
              Book Now
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PricingPlans;
